// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"
import axios from 'axios'
import qs from 'qs'
import './assets/less/app.less'
import './assets/js/pdfobject.min'
import pagination from './components/pagination.vue'
import HDialog from './components/Modal'
import tjkautocomplete from './components/tjkAutoComplete'
import tjkautocompleteall from './components/tjkAutoCompleteAll'
import providerautocomplete from './components/providerAutoComplete'
import children from './components/children'
// import VueLazyload from 'vue-lazyload'

import jquery from 'jquery'
import mixin from '@/mixins/common'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import animate from 'animate.css'

/******** 发送请求前配置请求及参数 ********/
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.interceptors.request.use((config) => {
    if (config.url.match(new RegExp('^.*/json/.*$'))) {
        axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    } else {
        axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    }
    if (config.method === 'post') {
        var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
            arrValue = (arr != null) ? unescape(arr[2]) : null
        if (arr) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            //小助手接口不添加tjk-login-token
            if (!config.url.match(new RegExp('^.*/hawkeye/action/.*$'))) {
                config.headers.common['tjk-login-token'] = `${arrValue}`;
                config.headers.common['tjk_login_token'] = `${arrValue}`;
            }
            config.headers.common['login_token'] = `${arrValue}`;
        }
        // 上传到七牛时如果在参数中添加login_token会报错
        if (config.url == 'http://upload.qiniu.com' || config.url == '//upload-z0.qiniup.com') return config
        if (config.url.match(new RegExp('^.*/simulationExercise/reply/importReply.*$'))) return config
        if (config.url.match(new RegExp('^.*/json/.*$')) || config.url.match(new RegExp('^.*/hawkeye/action/.*$'))) return config

        if (!config.data) config.data = {}
        config.data.tjk_login_token = (arr != null) ? unescape(arr[2]) : null
        config.data = qs.stringify(config.data, { allowDots: true })
    }
    if (config.method === 'get') {
        var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
            arrValue = (arr != null) ? unescape(arr[2]) : null
        if (arr) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.common['tjk-login-token'] = `${arrValue}`;
            config.headers.common['tjk_login_token'] = `${arrValue}`;
            config.headers.common['login_token'] = `${arrValue}`;
        }
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

axios.interceptors.response.use((res) => {
    if (!res.data.success && res.data.data == 201) {
        if (confirm('跳转到登陆?')) {
            var ua = window.navigator.userAgent.toLowerCase();
            if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
                window.location.href = '/college/sso/authorize';
                return;
            } else {
                window.location.href = '/customer/sso/authorize?25';
                return;
            }
        }
    }
    return res
}, (error) => {
    _.toast("网络异常", 'fail')
    return Promise.reject(error)
})

Vue.prototype.$http = axios
    /******** 发送请求前配置请求及参数 END ********/
    // 提示语公用方法
Vue.prototype.notify = function(msg) {
    this.$notify({
        title: '',
        dangerouslyUseHTMLString: true,
        message: msg,
        showClose: false,
        offset: 100,
        showClose: true
    });
}
Vue.config.productionTip = false

// 注册弹窗组件c
Vue.component(HDialog.name, HDialog)

// 注册分页组件
Vue.component(pagination.name, pagination)
    // 注册自动搜索组件
Vue.component(tjkautocomplete.name, tjkautocomplete)
Vue.component(tjkautocompleteall.name, tjkautocompleteall)
Vue.component(providerautocomplete.name, providerautocomplete)
Vue.component(children.name, children)

// 注册ElementUI
Vue.use(ElementUI)

Vue.mixin(mixin)

// Vue.use(VueLazyload)

router.beforeEach((to, from, next) => {
    if (from && from.path) {
        sessionStorage.setItem('prevRoutePath', from.path)
    } else {
        sessionStorage.removeItem('prevRoutePath')
    }
    next()
})

router.onError((error) => {
    var pattern = /Loading chunk (\d)+ failed/g
    var isChunkLoadFailed = error.message.match(pattern)
    if (isChunkLoadFailed) {
        var targetPath = router.history.pending.fullPath
        if (router.__chunkRetryCount && router.__chunkRetryCount >= 1) {
            if (confirm('页面资源已更新，请刷新页面以获取最新版本？')) {
                window.location.reload()
            }
        } else {
            router.__chunkRetryCount = (router.__chunkRetryCount || 0) + 1
            setTimeout(() => {
                router.replace(targetPath)
            }, 500)
        }
    }
})

Vue.config.errorHandler = function(err, vm, info) {
    console.error('Vue Error:', err, info)
}

window.onerror = function(message, source, lineno, colno, error) {
    if (message.indexOf('Unexpected token') !== -1 || message.indexOf('Loading chunk') !== -1) {
        if (confirm('页面资源已更新，请刷新页面以获取最新版本？')) {
            window.location.reload()
        }
    }
    return true
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js